import { App } from 'vue'
import DateTimePicker from './LpDateTimePicker.vue'

// @ts-ignore
DateTimePicker.install = (Vue: App) => {
  Vue.component(DateTimePicker.name, DateTimePicker)
}

export default DateTimePicker
